import {Audio, Video, VideoList, Texture ,Model3D} from '@/store/flux360/MediaManagerDataTypes';

class MediaManager 
{
    get defaultTransitionTextureID() { return -1; }
    
    constructor() {
        this.media = [];
        this.supportedMediaTypes = new Map();
        this.oCanvas = document.createElement('canvas');
        this.oCanvas.height = 83;
        this.oCanvas.width = 83;       
    }

    clear() {
        this.media = [];
    }

    registerMediaType( media ) {
        if( media.getType ) {
            this.supportedMediaTypes.set( media.getType(), media );
        }
    }

    hasMedia( id ) { return this.media.find( x => x.getID() === id ) != undefined; }
    getMedia( id ) { return this.media.find( x => x.getID() === id );  }
    addMedia( media ) {
        this.media.push( media );
        return this;
    }

    getMediaList(){ return this.media };

    hasMediaWithType( id, type ) { return this.hasMedia( id ) && this.getMedia( id ).hasType( type ); }

    // Go through the content and resolve the content
    // using the CMS...
    resolveContent( fluxCMS, contentIDs = undefined ) {
        console.log("MediaManager::resolveContent");
        // Iterate through all media...
        var retrievals =  [];
        var updateURL = media => 
        {   
            if( contentIDs )
                if( !contentIDs.includes( media.getContentID() ) )
                    return;
                    
            if( !media.getURL() ) {
                if( !media.getRequiresDirectURL() ) {
                   media.setURL( fluxCMS.getRawContentFileURL( media.getContentID() ) );
                } else {
                    retrievals.push(fluxCMS.getRawContentFileURLURL( media.getContentID() )
                        .then( url => media.setURL( url ))
                        .catch( () => media.setURL( fluxCMS.getRawContentFileURL( media.getContentID() ) ))
                    )
                }
            }
        }

        this.media.forEach( updateURL );
        return Promise.all(retrievals).then( () => console.log("All direct URLS resolved") );
    }

    summary() {
        return `
            MediaManager
            ::::::::::::
            Medien: ${this.media.size}
            `;
    }

    toJSON() {
        return {
            media: this.media.map( x => x.toJSON() ),
        }
    }

    createFromJSON( json ) {
        if( json && json.type || json.type == 0) {
            if( this.supportedMediaTypes.has( json.type ) )        
                return this.supportedMediaTypes.get( json.type ).createFromJSON( json );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype: " + json.type + " in " + json);
        }
    }

    getUserAvatar( user ){
        console.log("MediaManager getUserAvatar!! " + user.getColor() + " " + user.getAcronym());
          var context = this.oCanvas.getContext("2d");
          let color = "" + user.getColor();
          color = color.replace("0x", "#");
          context.fillStyle = color;
          context.fillRect(0, 0, 83, 83);
          context.fillStyle= "white";
          context.font = '40px roboto, sans-serif';
          context.textAlign = 'center';      
          context.fillText(user.getAcronym(), 41 ,57, 76);
         
          // no argument defaults to image/png; image/jpeg, etc also work on some
          // implementations -- image/png is the only one that must be supported per spec.
          let url = this.oCanvas.toDataURL("image/png");

          //only set value if it is valid
          if( user.getAcronym()!= undefined && user.getColor()!= undefined){
             user.setUserIcon(url);
          }
          return url;
    }
}

const instance = new MediaManager();
Object.freeze(instance);

instance.registerMediaType( new Audio() );
instance.registerMediaType( new Video() );
instance.registerMediaType( new VideoList() );
instance.registerMediaType( new Texture() );
instance.registerMediaType( new Model3D() );

export default instance;
